exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".document-attachment[data-v-4c2aef52] {\n  align-items: center;\n  margin-bottom: 12px;\n  border: thin solid #bbb;\n  padding: 5px;\n}\n.document-note[data-v-4c2aef52] {\n  font-size: 0.9em;\n  color: #666;\n}", ""]);

// exports
